import React from "react";
import img1 from "../assets/Landing Page Image 2.jpg";

const NetworkSection: React.FC = () => {
  return (
    <section className="network-section">
      <div className="network-container">
         
        <div className="network-image">
          <img src={img1} alt="Tiny Home Network" />
        </div>
      </div>
    </section>
  );
};

export default NetworkSection;
